import myAxios from '@/utils/request';
import {
  AddUserProps,
  DeleteUserProps,
  EmployeeByNameProps,
  RolePageListProps,
  UpdateUserProps,
  UserDetailProps,
  UserListProps
} from './type';
interface ResponseProps {
  data?: any;
  rolesPage?: any;
  current?: number;
  total?: number;
  records?: any;
  users?: any;
  dictList?: any;
  list?: any;
  provinceCode: string;
  provinceName: string;
  cityCode: string;
  cityName: string;
  userTypesId: string;
  realName?: string;
  address: {
    city?: {
      name: string;
      code: string;
    }[];
    name: string;
    code: string;
  }[];
  salesType?: number;
}

//角色列表接口
const queryRolePageList = (data: RolePageListProps): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/role/queryRolePageList',
    method: 'post',
    data
  });
};

//查询用户详情
const getUserDetail = (data: UserDetailProps): Promise<ResponseProps> => {
  return myAxios({ url: '/system/user/getUserDetail', method: 'post', data });
};

//查询用户列表
const queryUserList = (data: UserListProps): Promise<ResponseProps> => {
  return myAxios({ url: '/system/user/queryUserList', method: 'post', data });
};

//添加用户
const addUser = (data: AddUserProps): Promise<ResponseProps> => {
  return myAxios({ url: '/system/user/addUser', method: 'post', data });
};

//修改用户
const updateUser = (data: UpdateUserProps): Promise<ResponseProps> => {
  return myAxios({ url: '/system/user/updateUser', method: 'post', data });
};

//删除
const delUser = (data: DeleteUserProps): Promise<ResponseProps> => {
  return myAxios({ url: '/system/user/delUser', method: 'post', data });
};

//模糊查询用户
const getEmployeeByName = (
  data: EmployeeByNameProps
): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/user/getEmployeeByName',
    method: 'post',
    data
  });
};

//查询用户资源
const getUserResourceList = (): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/user/getUserResourceList',
    method: 'post',
    data: null
  });
};

//查询用户上级
const getUserLeaderByEid = (eid: string): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/user/getUserLeaderByEid',
    method: 'post',
    data: { eid }
  });
};

//Sector等 选项字典
const querySystemDict = (dictType?: string): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/dict/querySystemDict',
    method: 'post',
    data: { dictType }
  });
};

//省市
const querySystemCity = (): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/city/querySystemCity',
    method: 'post'
    // data: { dictType }
  });
};

const checkUserExist = (employId?: string): Promise<ResponseProps> => {
  return myAxios({
    url: '/system/user/checkUserExist',
    method: 'post',
    data: { employId }
  });
};

export {
  addUser,
  checkUserExist,
  delUser,
  getEmployeeByName,
  getUserDetail,
  getUserLeaderByEid,
  getUserResourceList,
  queryRolePageList,
  querySystemCity,
  querySystemDict,
  queryUserList,
  updateUser
};
